import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const taxAPI = {
  incomeTax: (p) => axios.post(`${API}/tax/income`, p).then((r) => r.data),
  brackets: (fs) => axios.get(`${API}/tax/brackets`, { params: { filing_status: fs } }).then((r) => r.data),
  standardDeduction: (fs) => axios.get(`${API}/tax/standard-deduction`, { params: { filing_status: fs } }).then((r) => r.data),
  childTaxCredit: (p) => axios.post(`${API}/tax/child-tax-credit`, p).then((r) => r.data),
  capitalGains: (p) => axios.post(`${API}/tax/capital-gains`, p).then((r) => r.data),
  salt: (p) => axios.post(`${API}/tax/salt`, p).then((r) => r.data),
  qbi: (p) => axios.post(`${API}/tax/qbi`, p).then((r) => r.data),
  estate: (p) => axios.post(`${API}/tax/estate`, p).then((r) => r.data),
  tips: (p) => axios.post(`${API}/tax/tips`, p).then((r) => r.data),
  overtime: (p) => axios.post(`${API}/tax/overtime`, p).then((r) => r.data),
  senior: (p) => axios.post(`${API}/tax/senior`, p).then((r) => r.data),
  autoLoan: (p) => axios.post(`${API}/tax/auto-loan`, p).then((r) => r.data),
  states: () => axios.get(`${API}/states`).then((r) => r.data),
  stateDetail: (slug) => axios.get(`${API}/states/${slug}`).then((r) => r.data),
  stateCombined: (p) => axios.post(`${API}/tax/state-combined`, p).then((r) => r.data),
};

export const contentAPI = {
  blogList: () => axios.get(`${API}/blog/posts`).then((r) => r.data),
  blogPost: (slug) => axios.get(`${API}/blog/post/${slug}`).then((r) => r.data),
  subscribe: (email) => axios.post(`${API}/newsletter/subscribe`, { email }).then((r) => r.data),
  contact: (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data),
};

export const formatCurrency = (n, digits = 0) =>
  new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD",
    minimumFractionDigits: digits, maximumFractionDigits: digits,
  }).format(Number(n || 0));

export const formatPercent = (n, digits = 2) => `${Number(n || 0).toFixed(digits)}%`;
